import React, { useState } from 'react';
import { Fade, makeStyles, Typography } from '@material-ui/core';
import HeaderBar from '../components/HeaderBar';
import MenuDrawer from '../components/MenuDrawer';
import LoginContextProvider from '../contexts/LoginContext';
import { Bold } from '../components/UI/TextFormatters';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    // height: '100vh',
    // backgroundColor: 'rgb(0,0,0,.5)',
    // backgroundColor: 'rgb(255,255,255,1)',
    backgroundColor: '#fafafa',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    marginTop: theme.mixins.toolbar.minHeight,
    padding: theme.spacing(3),
  },
}));

const HomeLayout = ({ children }) => {
  const classes = useStyles();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [screenTitle, setScreenTitle] = useState('');

  return (
    <Fade in={true} timeout={500}>
      <div className={classes.root}>
        <LoginContextProvider>
          <HeaderBar openDrawer={openDrawer} setOpenDrawer={setOpenDrawer} />
          <MenuDrawer openDrawer={openDrawer} setOpenDrawer={setOpenDrawer} setScreenTitle={setScreenTitle} />
          <div className={classes.toolbar} />

          <main className={classes.content}>
            <Typography>
              <Bold>{screenTitle}</Bold>
            </Typography>
            {children}
          </main>
        </LoginContextProvider>
      </div>
    </Fade>
  );
};

export default HomeLayout;
